import {IconViewModel} from "./IconViewModel";

export class ObjectLiteViewModel {
  Id: number = 0;
  Name: string = "";
  Comment: string = "";
  IMEI: string;
  Phone: string = "";
  Model: string = "";
  Icon: IconViewModel;
  IconId: number;
  OwnerId: number;
  Status: number;
  CompanyId: number;
  IsChecked: boolean;
  CreateDate: Date;
  CreateUnix: number;

  init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.Name = data["name"];
      this.OwnerId = data["companyId"];
      this.CompanyId = data["companyId"];
      this.Comment = data["comment"];
      this.IMEI = data["imei"];
      this.Phone = data["phone"];
      this.Model = data["deviceType"];
      this.Status = data["status"];
      this.Icon = IconViewModel.fromJS(data["icon"])
      this.IconId = data["iconId"];
      this.CreateUnix = data["createDate"];
    }
  }

  static fromJS(data: any): ObjectLiteViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ObjectLiteViewModel();
    result.init(data);
    return result;
  }
}
